import { render, staticRenderFns } from "./GlossaryLinkedCultures.vue?vue&type=template&id=1b3b177e&"
import script from "./GlossaryLinkedCultures.vue?vue&type=script&lang=js&"
export * from "./GlossaryLinkedCultures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports